import { TextField, styled } from "@mui/material";

const StyledTextField = styled(TextField)(({ theme }) => ({
  width: "100%",
  "& .MuiInputLabel-root.MuiInputLabel-shrink": {
    color: "#4b4c57ff !important", // Cor do label do input
    fontWeight: "bold",
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: "4px",
    backgroundColor: "#fff",
    "& fieldset": {
      borderColor: "#E0E0E0",
    },
    "&:hover fieldset": {
      borderColor: "#BDBDBD",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#0270a6",
      borderWidth: "1px",
    },
    // Estilo do input
    "& .MuiInputBase-input": {
      fontWeight: "bold",
      color: "#424242",
      "&.MuiAutocomplete-input": {
        padding: "2.5px 14px !important", // padding específico para o Autocomplete
      },
      // Estilo do placeholder
      "&::placeholder": {
        color: "var(--input-placeholder-color)",
        opacity: 1,
        fontWeight: "normal",
      },
    },
  },
  // Estilo do ícone (Adornment)
  "& .MuiInputAdornment-root": {
    color: "#5A5C69",
    "& .MuiSvgIcon-root, .svg-inline--fa": {
      color: "inherit",
    },
  },
  // Estilo do helper text
  "& .MuiFormHelperText-root": {
    marginLeft: "0",
  },
  // Estilo do input desabilitado
  "& .Mui-disabled": {
    backgroundColor: "#EBEBEB",
    borderRadius: "4px",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#DEDEDE !important",
      borderWidth: "1px !important",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#DEDEDE !important",
    },
    "& .MuiInputBase-input": {
      color: "#616161", // Cor do texto quando há dados
      "-webkit-text-fill-color": "#616161",
      "&::placeholder": {
        color: "#9e9e9e",
        opacity: 1,
        fontWeight: "normal",
        "-webkit-text-fill-color": "#9e9e9e", // Para Safari
      },
    },
    "& .MuiInputAdornment-root": {
      color: "#A0A0A0",
    },
  },
}));

export default StyledTextField;
